Wee.fn.make('services', {
	init: function() {
		var priv = this.$private;

		Wee.identoMap.initSearch({
			mapUrl: '/locations'
		});

		$.screen.map([
			{
				max: 3,
				init: false,
				callback: function() {
					priv.disableMenu();

					Wee.sticky.destroy();
				},
				namespace: 'services'
			},
			{
				max: 3,
				callback: function() {
					priv.bindEvents();
				},
				namespace: 'services'
			},
			{
				min: 4,
				callback: function() {
					$('ref:servicesLinks').show();
					$.events.off(false, '.services');

					Wee.sticky.init('ref:servicesNavInner', {
						container: 'ref:mainContent',
						start: 80,
						interval: 0
					});
				},
				namespace: 'services'
			}
		]);
	},
	unload: function() {
		$.screen.reset('services');
		$.events.off(false, '.services');

		Wee.sticky.destroy();
	}
}, {
	/**
	 * Bind events
	 *
	 * @private
	 */
	bindEvents: function() {
		$('ref:servicesToggle').on('click.services', function(e, el) {
			! $(el).isSelected() ? this.enableMenu() : this.disableMenu();
		}, {
			scope: this
		});
	},

	/**
	 * Enable menu
	 *
	 * @private
	 */
	enableMenu: function() {
		$('ref:servicesToggle').select();
		$('ref:servicesLinks').show()
			.removeAttr('aria-hidden');
	},

	/**
	 * Disable menu
	 *
	 * @private
	 */
	disableMenu: function() {
		$('ref:servicesToggle').unselect();
		$('ref:servicesLinks').hide()
			.attr('aria-hidden', true);
	}
});